import * as React from 'react';
import type { SVGProps } from 'react';
const SvgEyeShow = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M10 11.833a1.833 1.833 0 1 0 0-3.667 1.833 1.833 0 0 0 0 3.667m0 1.5a3.333 3.333 0 1 0 0-6.667 3.333 3.333 0 0 0 0 6.667"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M6.462 7.035c-1.077.75-1.972 1.683-2.57 2.39-.21.248-.31.37-.37.47-.039.063-.039.08-.039.103v.004c0 .023 0 .04.038.103.06.1.162.222.372.47.597.707 1.492 1.64 2.57 2.39 1.082.754 2.292 1.285 3.537 1.285s2.455-.53 3.538-1.285c1.077-.75 1.972-1.683 2.57-2.39.21-.248.31-.37.37-.47.039-.063.039-.08.039-.103v-.004c0-.023 0-.04-.038-.103-.06-.1-.162-.222-.372-.47-.597-.707-1.492-1.64-2.57-2.39C12.456 6.281 11.246 5.75 10 5.75s-2.455.53-3.538 1.285m-.857-1.23C6.824 4.954 8.333 4.25 10 4.25c1.668 0 3.176.705 4.395 1.554 1.223.852 2.213 1.89 2.857 2.651l.068.08c.325.38.697.816.697 1.465s-.372 1.084-.697 1.465l-.068.08c-.644.761-1.634 1.799-2.857 2.65-1.219.85-2.727 1.555-4.395 1.555s-3.176-.705-4.395-1.554c-1.223-.852-2.213-1.89-2.857-2.651l-.068-.08c-.325-.38-.697-.816-.697-1.465s.372-1.084.697-1.465l.068-.08c.644-.761 1.634-1.799 2.857-2.65"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgEyeShow;
